export default __webpack_public_path__ + "static/media/PremRaval.14683de4.jpg";